export enum ComparingEnum {
  BAD = "BAD",
  EQUAL = "EQUAL",
  GOOD = "GOOD",
  NONE = "NONE",
}
